import { render } from "./DeviceAlarmsNotificationSubscription.vue?vue&type=template&id=770c7e98"
import script from "./DeviceAlarmsNotificationSubscription.vue?vue&type=script&lang=js"
export * from "./DeviceAlarmsNotificationSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__